import { ModulesEnabledForSwitch, Module } from 'owa-bootstrap';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isNative } from 'owa-config';

const enabledModules: {
    [P in ModulesEnabledForSwitch]: boolean;
} = { Mail: true, Calendar: true, People: true, FilesHub: true, OutlookSpaces: false };

export function isModuleSwitchEnabled(currentModule: Module, newModule: Module) {
    const featureEnabled = isNative() || isFeatureEnabled('fwk-module-switch');
    return featureEnabled && enabledModules[currentModule] && enabledModules[newModule];
}
